// extracted by mini-css-extract-plugin
module.exports = {"root":"Accordion_root__zrSFX","active":"Accordion_active__2XVtl","accordionContent":"Accordion_accordionContent__pdtBn","disabled":"Accordion_disabled__208sG"};